export const CATEGORIES = {
    NOTICE: "NOTICE",           // 공지
    ISSUE: "ISSUE",             // 이슈
    NEWS: "NEWS",               // 화물구직
    JOB_POSTING: "JOB_POSTING", // 채용공고
    POPUP: "POPUP"              // 팝업 전용
};

// 화면 표시용 한글 레이블
export const CATEGORY_LABELS = {
    [CATEGORIES.NOTICE]: "공지",
    [CATEGORIES.ISSUE]: "소식",
    [CATEGORIES.NEWS]: "화물구직",
    [CATEGORIES.JOB_POSTING]: "채용공고",
    [CATEGORIES.POPUP]: "팝업"
};

export const DEADLINE_TYPES = {
    ALWAYS: "상시모집",
    UNTIL_HIRED: "채용시",
    DEADLINE: "마감일"
};